import { Dispatch, RefObject } from "react";
import { react } from "uikit";

import PlatonPaymentsCurrency from "./components/PlatonPaymentsCurrency";
import PlatonPaymentsCountryIso from "./components/PlatonPaymentsCountryIso";

interface Context {
	platonClientKey: string;
	platonClientPassword: string;
	platonApiUrl: string;
	currencyRef: RefObject<PlatonPaymentsCurrency.Ref | null>;
	countryIsoRef: RefObject<PlatonPaymentsCountryIso.Ref | null>;
	setPlatonClientKeyError: Dispatch<boolean>;
	setPlatonClientPasswordError: Dispatch<boolean>;
	setPlatonApiUrlError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isCurrency = this.context?.currencyRef.current?.validate();
		const isCountryIso = this.context?.countryIsoRef.current?.validate();
		const isClientKey = !!this.context?.platonClientKey.trim();
		const isClientPassword = !!this.context?.platonClientPassword.trim();
		const isApiUrl = !!this.context?.platonApiUrl.trim();

		if (!isClientKey) {
			this.context?.setPlatonClientKeyError(true);
		}

		if (!isClientPassword) {
			this.context?.setPlatonClientPasswordError(true);
		}

		if (!isApiUrl) {
			this.context?.setPlatonApiUrlError(true);
		}

		return [
			isCurrency,
			isCountryIso,
			isClientKey,
			isClientPassword,
			isApiUrl,
		].every(Boolean);
	}
}
